var cov_pd2hvn4wg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/Image.tsx",
      hash = "451e5ffee23c0d47ab9cf1d1f53ab6c4adfe427a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/Image.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 58
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "1": {
        start: {
          line: 22,
          column: 13
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "2": {
        start: {
          line: 26,
          column: 13
        },
        end: {
          line: 26,
          column: 56
        }
      },
      "3": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "4": {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "5": {
        start: {
          line: 50,
          column: 32
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "6": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 16
        }
      },
      "7": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 52
        }
      },
      "8": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 58
        }
      },
      "9": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 54
        }
      },
      "10": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "11": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 30
        }
      },
      "12": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 108,
          column: 6
        }
      },
      "13": {
        start: {
          line: 74,
          column: 28
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "14": {
        start: {
          line: 75,
          column: 70
        },
        end: {
          line: 75,
          column: 72
        }
      },
      "15": {
        start: {
          line: 76,
          column: 21
        },
        end: {
          line: 76,
          column: 37
        }
      },
      "16": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 105,
          column: 7
        }
      },
      "17": {
        start: {
          line: 79,
          column: 21
        },
        end: {
          line: 79,
          column: 47
        }
      },
      "18": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 24
        }
      },
      "19": {
        start: {
          line: 82,
          column: 22
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "20": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 90,
          column: 9
        }
      },
      "21": {
        start: {
          line: 84,
          column: 10
        },
        end: {
          line: 88,
          column: 11
        }
      },
      "22": {
        start: {
          line: 86,
          column: 14
        },
        end: {
          line: 86,
          column: 37
        }
      },
      "23": {
        start: {
          line: 89,
          column: 10
        },
        end: {
          line: 89,
          column: 18
        }
      },
      "24": {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 103,
          column: 9
        }
      },
      "25": {
        start: {
          line: 92,
          column: 10
        },
        end: {
          line: 95,
          column: 11
        }
      },
      "26": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 25
        }
      },
      "27": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 18
        }
      },
      "28": {
        start: {
          line: 96,
          column: 22
        },
        end: {
          line: 96,
          column: 38
        }
      },
      "29": {
        start: {
          line: 97,
          column: 10
        },
        end: {
          line: 101,
          column: 11
        }
      },
      "30": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 53
        }
      },
      "31": {
        start: {
          line: 98,
          column: 45
        },
        end: {
          line: 98,
          column: 53
        }
      },
      "32": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 31
        }
      },
      "33": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 38
        }
      },
      "34": {
        start: {
          line: 102,
          column: 10
        },
        end: {
          line: 102,
          column: 23
        }
      },
      "35": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 24
        }
      },
      "36": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 32
        }
      },
      "37": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 40
        }
      },
      "38": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 59
        }
      },
      "39": {
        start: {
          line: 113,
          column: 26
        },
        end: {
          line: 113,
          column: 59
        }
      },
      "40": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 40
        }
      },
      "41": {
        start: {
          line: 121,
          column: 66
        },
        end: {
          line: 121,
          column: 76
        }
      },
      "42": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 122,
          column: 37
        }
      },
      "43": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "44": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 32
        }
      },
      "45": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 14
        }
      },
      "46": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 44
        }
      },
      "47": {
        start: {
          line: 130,
          column: 18
        },
        end: {
          line: 130,
          column: 35
        }
      },
      "48": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 149,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 58
          },
          end: {
            line: 10,
            column: 59
          }
        },
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 56
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 83
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 73,
            column: 23
          },
          end: {
            line: 73,
            column: 24
          }
        },
        loc: {
          start: {
            line: 73,
            column: 44
          },
          end: {
            line: 108,
            column: 5
          }
        },
        line: 73
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 23
          }
        },
        loc: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 105,
            column: 7
          }
        },
        line: 78
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 83,
            column: 24
          },
          end: {
            line: 83,
            column: 25
          }
        },
        loc: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 90,
            column: 9
          }
        },
        line: 83
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 85,
            column: 18
          },
          end: {
            line: 85,
            column: 19
          }
        },
        loc: {
          start: {
            line: 85,
            column: 27
          },
          end: {
            line: 87,
            column: 13
          }
        },
        line: 85
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 24
          }
        },
        loc: {
          start: {
            line: 91,
            column: 29
          },
          end: {
            line: 103,
            column: 9
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 40
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 111
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 20
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 11
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 120
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 125,
            column: 32
          },
          end: {
            line: 125,
            column: 33
          }
        },
        loc: {
          start: {
            line: 125,
            column: 38
          },
          end: {
            line: 127,
            column: 7
          }
        },
        line: 125
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 44
          },
          end: {
            line: 23,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 44
          },
          end: {
            line: 23,
            column: 52
          }
        }, {
          start: {
            line: 23,
            column: 56
          },
          end: {
            line: 23,
            column: 66
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 68
          },
          end: {
            line: 23,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 68
          },
          end: {
            line: 23,
            column: 78
          }
        }, {
          start: {
            line: 23,
            column: 82
          },
          end: {
            line: 23,
            column: 102
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 27
          },
          end: {
            line: 33,
            column: 29
          }
        }, {
          start: {
            line: 33,
            column: 32
          },
          end: {
            line: 33,
            column: 33
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 7
          },
          end: {
            line: 36,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 7
          },
          end: {
            line: 36,
            column: 15
          }
        }, {
          start: {
            line: 36,
            column: 19
          },
          end: {
            line: 36,
            column: 102
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 60
          },
          end: {
            line: 36,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 60
          },
          end: {
            line: 36,
            column: 70
          }
        }, {
          start: {
            line: 36,
            column: 74
          },
          end: {
            line: 36,
            column: 97
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 28
          },
          end: {
            line: 74,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 28
          },
          end: {
            line: 74,
            column: 48
          }
        }, {
          start: {
            line: 74,
            column: 52
          },
          end: {
            line: 74,
            column: 54
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        }, {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 101,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 101,
            column: 11
          }
        }, {
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 101,
            column: 11
          }
        }],
        line: 97
      },
      "8": {
        loc: {
          start: {
            line: 98,
            column: 12
          },
          end: {
            line: 98,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 12
          },
          end: {
            line: 98,
            column: 53
          }
        }, {
          start: {
            line: 98,
            column: 12
          },
          end: {
            line: 98,
            column: 53
          }
        }],
        line: 98
      },
      "9": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 59
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 59
          }
        }],
        line: 113
      },
      "10": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 123
      },
      "11": {
        loc: {
          start: {
            line: 133,
            column: 59
          },
          end: {
            line: 133,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 133,
            column: 75
          },
          end: {
            line: 133,
            column: 84
          }
        }, {
          start: {
            line: 133,
            column: 87
          },
          end: {
            line: 133,
            column: 104
          }
        }],
        line: 133
      },
      "12": {
        loc: {
          start: {
            line: 143,
            column: 9
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 9
          },
          end: {
            line: 143,
            column: 19
          }
        }, {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 146,
            column: 16
          }
        }],
        line: 143
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/Image.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import immer from 'immer';
import classname from 'classnames';
import { uploadClass } from './styles';
import Upload from './Upload';
import { ERROR } from './request';
import { getLocale } from '../locale';
cov_pd2hvn4wg.s[0]++;
export var Handler = function Handler(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      urlInvalid = _ref.urlInvalid,
      children = _ref.children,
      style = _ref.style,
      width = _ref.width,
      height = _ref.height,
      onKeyDown = _ref.onKeyDown,
      onMouseDown = _ref.onMouseDown,
      otherProps = _objectWithoutProperties(_ref, ["className", "disabled", "urlInvalid", "children", "style", "width", "height", "onKeyDown", "onMouseDown"]);

  cov_pd2hvn4wg.f[0]++;
  var mc = (cov_pd2hvn4wg.s[1]++, classname(uploadClass('image-plus', 'image-item', (cov_pd2hvn4wg.b[0][0]++, disabled) && (cov_pd2hvn4wg.b[0][1]++, 'disabled'), (cov_pd2hvn4wg.b[1][0]++, urlInvalid) && (cov_pd2hvn4wg.b[1][1]++, 'url-invalid-border')), className));
  var ms = (cov_pd2hvn4wg.s[2]++, Object.assign({}, {
    width: width,
    height: height
  }, style));
  cov_pd2hvn4wg.s[3]++;
  return (
    /*#__PURE__*/
    React.createElement("div", Object.assign({}, otherProps, {
      onKeyDown: onKeyDown,
      onMouseDown: onMouseDown,
      style: ms,
      tabIndex: disabled ? (cov_pd2hvn4wg.b[2][0]++, -1) : (cov_pd2hvn4wg.b[2][1]++, 0),
      className: mc,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 5
      }
    }), (cov_pd2hvn4wg.b[3][0]++, children) || (cov_pd2hvn4wg.b[3][1]++,
    /*#__PURE__*/
    React.createElement("div", {
      className: uploadClass('indicator', (cov_pd2hvn4wg.b[4][0]++, urlInvalid) && (cov_pd2hvn4wg.b[4][1]++, 'url-invalid-indicator')),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 20
      }
    })))
  );
};
cov_pd2hvn4wg.s[4]++;
Handler.defaultProps = {
  width: 80,
  height: 80
};
var ImageUploadDefaultProps = (cov_pd2hvn4wg.s[5]++, {
  accept: 'image/*',
  height: 80,
  validator: {},
  width: 80
});

var Image =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper2(Image);

  function Image(props) {
    var _this2;

    _classCallCheck(this, Image);

    cov_pd2hvn4wg.f[1]++;
    cov_pd2hvn4wg.s[6]++;
    _this2 = _super.call(this, props);
    _this2.timeout = void 0;
    cov_pd2hvn4wg.s[7]++;
    _this2.beforeUpload = _this2.beforeUpload.bind(_assertThisInitialized(_this2));
    cov_pd2hvn4wg.s[8]++;
    _this2.handleMouseDown = _this2.handleMouseDown.bind(_assertThisInitialized(_this2));
    cov_pd2hvn4wg.s[9]++;
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    cov_pd2hvn4wg.s[10]++;
    _this2.state = {
      urlInvalid: false
    };
    cov_pd2hvn4wg.s[11]++;
    _this2.timeout = null;
    return _this2;
  }

  _createClass(Image, [{
    key: "beforeUpload",
    value: function beforeUpload(blob, validatorHandle) {
      var _this3 = this;

      cov_pd2hvn4wg.f[2]++;
      cov_pd2hvn4wg.s[12]++;
      return new Promise(function (resolve, reject) {
        cov_pd2hvn4wg.f[3]++;

        var _ref2 = (cov_pd2hvn4wg.s[13]++, (cov_pd2hvn4wg.b[5][0]++, _this3.props.validator) || (cov_pd2hvn4wg.b[5][1]++, {})),
            imageSize = _ref2.imageSize;

        var file = (cov_pd2hvn4wg.s[14]++, {});
        var reader = (cov_pd2hvn4wg.s[15]++, new FileReader());
        cov_pd2hvn4wg.s[16]++;

        reader.onload = function (e) {
          cov_pd2hvn4wg.f[4]++;
          var data = (cov_pd2hvn4wg.s[17]++, e.target.result);
          cov_pd2hvn4wg.s[18]++;
          file.data = data;
          var image = (cov_pd2hvn4wg.s[19]++, new window.Image());
          cov_pd2hvn4wg.s[20]++;

          image.onerror = function () {
            cov_pd2hvn4wg.f[5]++;
            cov_pd2hvn4wg.s[21]++;

            _this3.setState(immer(function (draft) {
              cov_pd2hvn4wg.f[6]++;
              cov_pd2hvn4wg.s[22]++;
              draft.urlInvalid = true;
            }));

            cov_pd2hvn4wg.s[23]++;
            reject();
          };

          cov_pd2hvn4wg.s[24]++;

          image.onload = function () {
            cov_pd2hvn4wg.f[7]++;
            cov_pd2hvn4wg.s[25]++;

            if (!imageSize) {
              cov_pd2hvn4wg.b[6][0]++;
              cov_pd2hvn4wg.s[26]++;
              resolve(file);
              cov_pd2hvn4wg.s[27]++;
              return;
            } else {
              cov_pd2hvn4wg.b[6][1]++;
            }

            var res = (cov_pd2hvn4wg.s[28]++, imageSize(image));
            cov_pd2hvn4wg.s[29]++;

            if (res instanceof Error) {
              cov_pd2hvn4wg.b[7][0]++;
              cov_pd2hvn4wg.s[30]++;

              if (!validatorHandle(res, blob)) {
                cov_pd2hvn4wg.b[8][0]++;
                cov_pd2hvn4wg.s[31]++;
                reject();
              } else {
                cov_pd2hvn4wg.b[8][1]++;
              }

              cov_pd2hvn4wg.s[32]++;
              file.status = ERROR;
              cov_pd2hvn4wg.s[33]++;
              file.message = res.message;
            } else {
              cov_pd2hvn4wg.b[7][1]++;
            }

            cov_pd2hvn4wg.s[34]++;
            resolve(file);
          };

          cov_pd2hvn4wg.s[35]++;
          image.src = data;
        };

        cov_pd2hvn4wg.s[36]++;
        reader.readAsDataURL(blob);
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_pd2hvn4wg.f[8]++;
      cov_pd2hvn4wg.s[37]++;
      this.setState({
        urlInvalid: false
      });
      cov_pd2hvn4wg.s[38]++;

      if (e.keyCode === 13) {
        cov_pd2hvn4wg.b[9][0]++;
        cov_pd2hvn4wg.s[39]++;
        e.target.click();
      } else {
        cov_pd2hvn4wg.b[9][1]++;
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      cov_pd2hvn4wg.f[9]++;
      cov_pd2hvn4wg.s[40]++;
      this.setState({
        urlInvalid: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      cov_pd2hvn4wg.f[10]++;

      var _ref3 = (cov_pd2hvn4wg.s[41]++, this.props),
          children = _ref3.children,
          width = _ref3.width,
          height = _ref3.height,
          ignorePreview = _ref3.ignorePreview,
          others = _objectWithoutProperties(_ref3, ["children", "width", "height", "ignorePreview"]);

      var _ref4 = (cov_pd2hvn4wg.s[42]++, this.state),
          urlInvalid = _ref4.urlInvalid;

      cov_pd2hvn4wg.s[43]++;

      if (urlInvalid) {
        cov_pd2hvn4wg.b[10][0]++;
        cov_pd2hvn4wg.s[44]++;
        clearTimeout(this.timeout);
        cov_pd2hvn4wg.s[45]++;
        this.timeout = setTimeout(function () {
          cov_pd2hvn4wg.f[11]++;
          cov_pd2hvn4wg.s[46]++;

          _this4.setState({
            urlInvalid: false
          });
        }, 3000);
      } else {
        cov_pd2hvn4wg.b[10][1]++;
      }

      var style = (cov_pd2hvn4wg.s[47]++, {
        width: width,
        height: height
      });
      cov_pd2hvn4wg.s[48]++;
      return (
        /*#__PURE__*/
        React.createElement(Upload, Object.assign({}, others, {
          imageStyle: style,
          beforeUpload: ignorePreview ? (cov_pd2hvn4wg.b[11][0]++, undefined) : (cov_pd2hvn4wg.b[11][1]++, this.beforeUpload),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 133,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Handler, {
          disabled: this.props.disabled,
          style: style,
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown,
          urlInvalid: urlInvalid,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134,
            columnNumber: 9
          }
        }, children), (cov_pd2hvn4wg.b[12][0]++, urlInvalid) && (cov_pd2hvn4wg.b[12][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            width: '100%',
            position: 'relative'
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('url-invalid-message'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 145,
            columnNumber: 13
          }
        }, getLocale('urlInvalidMsg')))))
      );
    }
  }]);

  return Image;
}(PureComponent);

Image.defaultProps = ImageUploadDefaultProps;
export default Image;